import { Typography, TypographyProps } from "@mui/material";
import { useState, useEffect } from "react";

interface TypewriterProps extends TypographyProps {
  text: string;
  speed?: number;
  startDelay?: number;
  finishDelay?: number;
  onFinishTyping?: () => void;
}

export const Typewriter = (props: TypewriterProps) => {
  const {
    text,
    speed = 50,
    startDelay = 100,
    finishDelay = 100,
    onFinishTyping,
    ...rest
  } = props;
  const [displayedText, setDisplayedText] = useState("");
  const [timerIndex, setTimerIndex] = useState(0);
  const [started, setStarted] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setStarted(true);
    }, startDelay);
  }, [startDelay]);

  useEffect(() => {
    if (!started) return;

    if (timerIndex <= text.length) {
      setDisplayedText(text.substring(0, timerIndex));

      const timer = setTimeout(() => {
        setTimerIndex((prevTimerIndex) => prevTimerIndex + 1);
      }, speed);

      return () => clearTimeout(timer);
    } else {
      setTimeout(() => {
        onFinishTyping?.();
      }, finishDelay);
    }
  }, [text, speed, timerIndex, started, finishDelay, onFinishTyping]);

  return <Typography {...rest}>{displayedText}</Typography>;
};
